export default timeStr => {
  const date = new Date(timeStr).getTime()
  const now = Date.now()
  const pass = now - date
  const oneHour = 1000 * 3600
  const oneDay = 24 * oneHour
  const hour48 = 1000 * 3600 * 48
  if (pass < oneHour) {
    return {
      num: '',
      unit: 'just',
    }
  } else if (pass < hour48) {
    return {
      num: Math.floor(pass / oneHour),
      unit: 'hour',
    }
  }
  return {
    num: Math.floor(pass / oneDay),
    unit: 'day',
  }
}
